/**
 * Project-shared named filter sets (URL query params scoped to a page pathname).
 */

export interface SavedFilter {
  id: string;
  pathname: string;
  name: string;
  /** URL query string without leading "?". */
  queryString: string;
  /** App user id who created this saved filter. */
  createdByUserId: string;
  createdAt: string;
  updatedAt: string;
}

export interface SavedFilterCreateInput {
  pathname: string;
  name: string;
  queryString: string;
}

export interface SavedFilterRenameInput {
  name: string;
}

export interface SavedFilterUpdateInput {
  name?: string;
  /** When set, replaces the stored query with the current page settings. */
  queryString?: string;
}

export const SAVED_FILTER_MAX_NAME_LENGTH = 100;
export const SAVED_FILTER_MAX_PATHNAME_LENGTH = 200;
export const SAVED_FILTER_MAX_QUERY_STRING_LENGTH = 4096;

/**
 * Paging params stripped when saving a named view. `pageSize` is the old
 * /collections-bulk-edit name for `limit`, still found in older links and views.
 */
export const SAVED_FILTER_EXCLUDED_QUERY_KEYS = ['page', 'limit', 'pageSize'] as const;
